import React, { useState, useEffect } from "react";
import "./App.css";
import { Login } from "./components/Login";
import { Dashboard } from "./components/Dashboard";

function App() {
  console.log("App component rendering...");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authStatus = sessionStorage.getItem('umts_admin_authenticated');
    const storedToken = localStorage.getItem('authToken');

    if (authStatus === 'true' && storedToken) {
      console.log("User is authenticated from session storage and valid token present.");
      setIsAuthenticated(true);
    } else if (authStatus === 'true' && !storedToken) {
      console.warn("Session flag set but missing auth token. Clearing session.");
      sessionStorage.removeItem('umts_admin_authenticated');
    }
  }, []);

  const handleLogin = (result) => {
    const isSuccessful = typeof result === 'boolean' ? result : Boolean(result?.success);

    if (isSuccessful) {
      const token = typeof result === 'object' ? result.token : null;
      console.log("Login successful, granting access to dashboard.", {
        tokenPresent: Boolean(token)
      });

      setIsAuthenticated(true);
      sessionStorage.setItem('umts_admin_authenticated', 'true');

      if (token) {
        localStorage.setItem('authToken', token);
      }
    }
  };

  const handleLogout = () => {
    console.log("Logging out.");
    setIsAuthenticated(false);
    sessionStorage.removeItem('umts_admin_authenticated');
    localStorage.removeItem('authToken');
  };

  const handleSelectApp = (appId) => {
    console.log(`handleSelectApp called with appId: ${appId}`);
    const routes = {
      'cliente-manager': '/app/client-manager/',
      'commission-pro': '/app/commission-pro/',
      'meo-dealer': '/app/meo-dealer/'
    };
    const target = routes[appId];
    if (target) {
      window.location.assign(target);
    } else {
      console.warn(`Unknown appId "${appId}" requested.`);
    }
  };

  let content;
  if (!isAuthenticated) {
    console.log("Rendering Login component.");
    content = <Login onLogin={handleLogin} />;
  } else {
    console.log("Rendering Dashboard component.");
    content = <Dashboard onLogout={handleLogout} onSelectApp={handleSelectApp} />;
  }

  return (
    <div className="App">
      {content}
    </div>
  );
}

export default App;